import * as React from 'react';
import { AriaButtonProps } from '@react-types/button';
import { Button as BaseButton, ButtonProps } from './Button';
import { useButton } from '@react-aria/button';

function Button(props: AriaButtonProps & ButtonProps, ref_: any) {
  let ref = React.useRef<any>(null);
  let { buttonProps } = useButton(props, ref);
  let { children, sx, variant, color, css } = props;

  React.useImperativeHandle(
    ref_,
    () => ({
      focus: () => {
        if (ref && ref?.current && ref?.current?.focus) {
          ref?.current?.focus();
        }
      }
    }),
    []
  );

  return (
    <BaseButton {...buttonProps} sx={sx} color={color} variant={variant} css={css} ref={ref}>
      {children}
    </BaseButton>
  );
}

export default React.forwardRef(Button);
